import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const enFillersCorrect = el.enFillers ? el.enFillers.split('\n') : [];

  return {
    ...el,
    partResults: {},
    enFillersCorrect,
    enPlaceholders: '',
    enFillersShuffled: [...enFillersCorrect],
  };
};
